import { CityHeaderNavUnstyled } from './unstyled'
import styled from 'styled-components'

export const CityHeaderNav = styled(CityHeaderNavUnstyled)``
